import React, { Fragment, PureComponent } from 'react';
import { number, func, string, bool, arrayOf } from 'prop-types';
import { UTLabel, WithLoading } from '@widergy/energy-ui';

import { appConfig } from 'config/customization';
import UTModal from 'app/components/UTModal';
import withErrorScreen from 'app/components/UTErrorScreen/HOCs/withErrorScreen';
import { message } from 'utils/stringUtils';
import { accountUnpaidType } from 'types/paymentTypes';

import PaymentsHeader from './components/PaymentsHeader';
import AccountPaymentDetails from './components/AccountPaymentDetails';
import styles from './styles';

class PaymentsScene extends PureComponent {
  render() {
    const {
      totalAmount,
      setTotalAmount,
      handleOnPress,
      handlePayment,
      openClientNumber,
      handleChangeCheckedAccount,
      checkedAccount,
      accountsWithUnpaid,
      handleExternalAccPayment,
      isPublic,
      onOpenPaymentDocumentModal,
      onClosePaymentDocumentModal,
      onDownloadPaymentDocument,
      paymentDocumentModalIsOpen
    } = this.props;
    return (
      <Fragment>
        <div style={styles.paymentsContainer}>
          <PaymentsHeader
            secondaryTopbarText={message('Payments:amount')}
            totalAmountText={
              appConfig.PaymentDocumentSelection
                ? message('Payments:totalAmount')
                : message('Payments:totalConditionalAmount')
            }
            totalAmount={totalAmount}
            handlePayment={handlePayment}
            handleExternalAccPayment={handleExternalAccPayment}
            isPublic={isPublic}
          />
          {accountsWithUnpaid &&
            accountsWithUnpaid.map(account => (
              <AccountPaymentDetails
                key={account.id}
                account={account}
                setTotalAmount={setTotalAmount}
                handleOnPress={handleOnPress(account.client_number)}
                handleChangeCheckedAccount={handleChangeCheckedAccount}
                checkedAccount={checkedAccount}
                onOpenPaymentDocumentModal={onOpenPaymentDocumentModal}
                isPublic={isPublic}
                isOpen={
                  (openClientNumber === account.client_number ||
                    (isPublic && appConfig.payments.paymentForNis)) &&
                  account.debts &&
                  account.debts.length > 0
                }
              />
            ))}
        </div>
        <UTModal
          isOpen={paymentDocumentModalIsOpen}
          onRequestClose={onClosePaymentDocumentModal}
          cancelButton={{
            onPress: onClosePaymentDocumentModal,
            text: message('Commons:cancel')
          }}
          acceptButton={{
            onPress: onDownloadPaymentDocument,
            text: message('Commons:accept')
          }}
          title={message('Payments:paymentDocumentModalTitle')}
        >
          <div style={styles.paymentDocumentModal}>
            <UTLabel>{message('Payments:paymentDocumentModalContent')}</UTLabel>
          </div>
        </UTModal>
      </Fragment>
    );
  }
}
PaymentsScene.propTypes = {
  isPublic: bool,
  totalAmount: number,
  setTotalAmount: func,
  handleOnPress: func,
  handlePayment: func,
  handleExternalAccPayment: func,
  handleChangeCheckedAccount: func,
  checkedAccount: string,
  openClientNumber: string,
  accountsWithUnpaid: arrayOf(accountUnpaidType),
  onOpenPaymentDocumentModal: func,
  onClosePaymentDocumentModal: func,
  onDownloadPaymentDocument: func,
  paymentDocumentModalIsOpen: bool
};

export default WithLoading(props => props.loading)(
  withErrorScreen(props => !props.accountsWithUnpaid && !props.loading)(PaymentsScene)
);
